import { CoreSelections } from '../../@types';
import { CoreSelectionsName } from './name';
import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { defaultSelectionState } from './state';

export type RemoveCoreSelectionActionData = {
	namespace?: string,
	selections: number[]
};

export const removeCoreSelectionsSyncSlice = createRemoveSyncSlice<
	typeof CoreSelectionsName,
	CoreSelections,
	RemoveCoreSelectionActionData
>({
	name: CoreSelectionsName,
	state: defaultSelectionState,
	transform: (action, state = {}) => {
		const namespace = action?.namespace ?? 'global';
		const selections = action?.selections ?? [];

		if (selections.length === 0) {
			state[ namespace ] = {};
		} else {
			selections.forEach((id) => {
				delete state[ namespace ][ id ];
			});
		}

		return state;
	}
});
